export const GA_TRACKING_ID = "G-DYVGSD2ST0";
